package io.horion.cv.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.DividerWithText
import io.horion.cv.components.Footer
import io.horion.cv.components.FormField
import io.horion.cv.components.SocialLoginButton
import io.horion.cv.components.TermsAndPrivacyText
import io.horion.cv.components.Topbar
import io.horion.cv.styles.AppleStyle
import io.horion.cv.styles.GoogleStyle
import io.horion.cv.styles.connectStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Constants.UBUNTU
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Page("inscription")
@Composable
fun RegisterInfo() {
    val ctx = rememberPageContext()
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint <= Breakpoint.MD
    val fieldWidth = if (isMobile) 300.px else 380.px

    var email by remember { mutableStateOf("") }
    var nom by remember { mutableStateOf("") }
    var prenom by remember { mutableStateOf("") }
    var telephone by remember { mutableStateOf("") }

    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Topbar()

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = if (isMobile) 40.px else 100.px, bottom = 40.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Column(
                modifier = Modifier
                    .margin(bottom = 50.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SpanText(
                    text = "Insription",
                    modifier = Modifier
                        .fontSize(if (isMobile) 24.px else 30.px)
                        .color(Colors.black)
                        .fontWeight(FontWeight.Normal)
                        .fontFamily(UBUNTU)
                        .margin(bottom = if(isMobile) 20.px else 30.px)
                )

                Row (
                    modifier = Modifier.gap(5.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SpanText(
                        text = "Vous avez déjà un compte?",
                        modifier = Modifier
                            .fontSize(if (isMobile) 15.px else 18.px)
                            .color(Colors.Primary)
                            .fontFamily(INTER)
                            .fontWeight(FontWeight.Normal)
                    )
                    Link(
                        path = "/connexion",
                        text = "Connectez-vous",
                        modifier = Modifier
                            .fontSize(if (isMobile) 15.px else 18.px)
                            .color(Colors.lighterblue)
                            .fontFamily(INTER)
                            .fontWeight(FontWeight.Medium)
                            .textDecorationLine(TextDecorationLine.None)
                    )
                }
            }

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .gap(20.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                FormField(
                    label = "Adresse e-mail",
                    value = email,
                    onValueChange = { email = it },
                    placeholder = "monadd@email.com",
                    type = InputType.Email,
                    fieldWidth = fieldWidth
                )

                FormField(
                    label = "Nom",
                    value = nom,
                    onValueChange = { nom = it },
                    placeholder = "Tagne Abena",
                    fieldWidth = fieldWidth
                )

                FormField(
                    label = "Prénoms",
                    value = prenom,
                    onValueChange = { prenom = it },
                    placeholder = "Amougou",
                    fieldWidth = fieldWidth
                )

                FormField(
                    label = "Téléphone",
                    value = telephone,
                    onValueChange = { telephone = it },
                    placeholder = "+237 677 77 77 77",
                    type = InputType.Tel,
                    fieldWidth = fieldWidth
                )

                Button(
                    onClick = { ctx.router.navigateTo("validation") },
                    modifier = connectStyle.toModifier()
                        .height(42.px)
                        .borderRadius(20.px)
                        .padding(topBottom = 10.px, leftRight = 20.px)
                        .fontSize(18.px)
                        .color(Colors.White)
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.Normal)
                        .margin(top = 40.px)
                        .align(Alignment.CenterHorizontally)
                ) {
                    Text("Suivant")
                }
            }

            DividerWithText(width = fieldWidth)

            Column(
                modifier = Modifier.fillMaxWidth().gap(10.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SocialLoginButton(
                    text = "Continuer avec Google",
                    iconSrc = "/google-icon.svg",
                    onClick = {},
                    modifier = GoogleStyle.toModifier(),
                    isMobile = isMobile
                )
                SocialLoginButton(
                    text = "Continuer avec icloud",
                    iconSrc = "/apple-logo.svg",
                    onClick = {},
                    modifier = AppleStyle.toModifier(),
                    isMobile = isMobile
                )
            }
            TermsAndPrivacyText(
                modifier = Modifier.margin(top = 40.px),
                conditionsPath = "/conditions",
                privacyPath = "/privacy",
                isMobile = isMobile
            )
        }

        Footer()
    }
}
